/**
 * @generated SignedSource<<6eb8647e1be9ca24fb88278189da3709>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ReactionViewerUser$data = {
  readonly id: string;
  readonly login: string;
  readonly " $fragmentType": "ReactionViewerUser";
};
export type ReactionViewerUser$key = {
  readonly " $data"?: ReactionViewerUser$data;
  readonly " $fragmentSpreads": FragmentRefs<"ReactionViewerUser">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ReactionViewerUser",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "login",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "67bb1de1dc3a288ccbd0d95cfebe1d9c";

export default node;
